import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Crosshair, Gauge, Calculator, ArrowRight } from 'lucide-react';

const HYROX_TOOLS = [
  { title: 'Finish Time Predictor', desc: 'Enter your benchmarks and get a predicted HYROX finish time with station splits.', icon: Zap, href: '/tools/hyrox-finish-time', color: '#e8ff00' },
  { title: 'Station Split Planner', desc: 'Break down your station target times based on goal finish time and running pace.', icon: Crosshair, href: '/tools/station-split', color: '#e8ff00' },
  { title: 'Race Pace Card', desc: 'Build a downloadable pace card with target splits for every run and station.', icon: Gauge, href: '/tools/race-pace', color: '#e8ff00' },
  { title: 'Macro Calculator', desc: 'Fuel your training with the right protein, carb, and fat split.', icon: Calculator, href: '/tools/macro-calculator', color: '#00F0FF' },
];

export const ToolsSection = () => (
  <section id="tools" className="bg-[#050505] section-spacing" data-testid="hyrox-tools-section">
    <div className="container-ninja">
      <div className="max-w-4xl mx-auto">
        <p className="text-[#e8ff00] text-xs uppercase tracking-wider font-heading mb-3">Race Day Tools</p>
        <h2 className="text-3xl md:text-4xl text-white font-heading mb-4">Plan Your Race. Hit Your Target.</h2>
        <p className="text-zinc-400 mb-8 max-w-2xl">
          Free calculators and planners built specifically for HYROX athletes. Predict your finish time, build your pace card, and dial in your nutrition.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {HYROX_TOOLS.map((t) => (
            <Link
              key={t.href}
              to={t.href}
              className="group bg-zinc-900/80 border border-zinc-800 hover:border-[#e8ff00]/40 p-6 transition-all flex items-start gap-4"
              data-testid={`hyrox-tool-${t.href.split('/').pop()}`}
            >
              <div className="w-12 h-12 flex items-center justify-center border border-zinc-700 flex-shrink-0" style={{ backgroundColor: `${t.color}10` }}>
                <t.icon className="w-5 h-5" style={{ color: t.color }} />
              </div>
              <div className="flex-1">
                <h3 className="text-white font-heading text-lg group-hover:text-[#e8ff00] transition-colors">{t.title}</h3>
                <p className="text-zinc-500 text-sm mt-1">{t.desc}</p>
              </div>
              <ArrowRight className="w-4 h-4 text-zinc-600 group-hover:text-[#e8ff00] mt-1 flex-shrink-0 transition-colors" />
            </Link>
          ))}
        </div>
        <div className="mt-4 text-center">
          <Link to="/tools" className="text-[#e8ff00] text-sm font-heading uppercase tracking-wider inline-flex items-center gap-2 hover:text-white transition-colors" data-testid="all-tools-link">
            View All Tools <ArrowRight className="w-3 h-3" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
